function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.87013 4.68831H2.96104C2.14337 4.68831 1.48052 5.35116 1.48052 6.16883V16.039C1.48052 16.8566 2.14337 17.5195 2.96104 17.5195H9.87013C10.6878 17.5195 11.3506 16.8566 11.3506 16.039V6.16883C11.3506 5.35116 10.6878 4.68831 9.87013 4.68831ZM2.96104 3.20779C1.3257 3.20779 0 4.53349 0 6.16883V16.039C0 17.6743 1.3257 19 2.96104 19H9.87013C11.5055 19 12.8312 17.6743 12.8312 16.039V6.16883C12.8312 4.53349 11.5055 3.20779 9.87013 3.20779H2.96104Z",
  fill: "#249AF3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.20779 3.20779C3.20779 1.43618 4.64397 0 6.41558 0H13.3247C15.0963 0 16.5325 1.43618 16.5325 3.20779V13.0779C16.5325 14.8495 15.0963 16.2857 13.3247 16.2857H12.1479V14.8052H13.3247C14.2786 14.8052 15.0519 14.0319 15.0519 13.0779V3.20779C15.0519 2.25385 14.2786 1.48052 13.3247 1.48052H6.41558C5.46164 1.48052 4.68831 2.25385 4.68831 3.20779V3.7013H3.20779V3.20779Z",
  fill: "#249AF3"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.71429 8.14286C2.71429 7.73402 3.04571 7.4026 3.45455 7.4026H9.37662C9.78546 7.4026 10.1169 7.73402 10.1169 8.14286C10.1169 8.55169 9.78546 8.88312 9.37662 8.88312H3.45455C3.04571 8.88312 2.71429 8.55169 2.71429 8.14286Z",
  fill: "#249AF3"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.71429 11.1039C2.71429 10.6951 3.04571 10.3636 3.45455 10.3636H9.37662C9.78546 10.3636 10.1169 10.6951 10.1169 11.1039C10.1169 11.5127 9.78546 11.8442 9.37662 11.8442H3.45455C3.04571 11.8442 2.71429 11.5127 2.71429 11.1039Z",
  fill: "#249AF3"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.71429 14.0649C2.71429 13.6561 3.04571 13.3247 3.45455 13.3247H9.37662C9.78546 13.3247 10.1169 13.6561 10.1169 14.0649C10.1169 14.4738 9.78546 14.8052 9.37662 14.8052H3.45455C3.04571 14.8052 2.71429 14.4738 2.71429 14.0649Z",
  fill: "#249AF3"
});

function SvgEmailPayOffLetterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailPayOffLetterIcon);
export default __webpack_public_path__ + "static/media/EmailPayOffLetterIcon.8304d739.svg";
export { ForwardRef as ReactComponent };